export const ACTIONS = {
  API_ERROR: "report/site/API_ERROR",
  SET_REPORT_OPTIONS: "report/site/SET_REPORT_OPTIONS"
};

export const setReportOptions = payload => dispatch => {
  dispatch({
    type: ACTIONS.SET_REPORT_OPTIONS,
    payload: payload
  });
};
export const setReportApiError = payload => dispatch => {
  dispatch({
    type: ACTIONS.API_ERROR,
    payload: { errorObject: payload?.errorObject || {} },
  });
};
